module.exports = __webpack_public_path__ + "img/perks-coming-soon-1.b6c455e5.png";